import $ from "jquery";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import DescriptionIcon from "@material-ui/icons/Description";
import Rating from "@material-ui/lab/Rating";
import { Player } from "video-react";
import "../../../assets/css/overlay.css";
import logo from "../../../assets/img/new_ss_logo.png";
import Loader from "../../../components/loader";
import axios from "axios";
import { API_ENDPOINT } from "../../../constants";
import { FooterWithHelpIcon } from "../../container/default-layout/footerWithHelpIcon";
import { altAttribute, MAX_CHARACTER_LIMITS_FOR_ELIPSIS } from "../../../utils/utils";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    "& > * + *": {
      marginTop: theme.spacing(1),
    },
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" align="center">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "450px",
    height: "350px",
  },
}))(MuiDialogContent);

const PublicSimDetail = () => {
  const params = useParams();
  const simId = params.simId;
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [open, setOpen] = useState(false);
  const [ratings, setRatings] = useState(0);
  const [simData, setSimData] = useState({
    simName: "",
    simDuration: "",
    detailText: "",
    preview: "",
    thumbnail: "",
    docFile1: null,
    docAccess1: "none",
    docName1: "",
    docFile2: null,
    docAccess2: "none",
    docName2: "",
    docFile3: null,
    docAccess3: "none",
    docName3: "",
    docFile4: null,
    docAccess4: "none",
    docName4: "",
    docFile5: null,
    docAccess5: "none",
    docName5: "",
    simFacilitatorDocumentsListBySimId: [],
  });
  const [showFullText, setShowFullText] = useState(false);

  const loadSimData = useCallback(async () => {
    setLoading(true);
    setLoadError(false);
    try {
      const response = await axios.get(`${API_ENDPOINT}sims/${simId}`);
      setSimData(response.data);
    } catch (error) {
      console.error("Error loading simulation:", error);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [simId]);

  const loadRatings = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}sims/getAverageRatingsBySim/${simId}`
      );
      // MUI Rating needs a number; the API may return null or a string
      const value = Number(response.data);
      setRatings(Number.isFinite(value) ? value : 0);
    } catch (error) {
      console.error("Error loading ratings:", error);
    }
  }, [simId]);

  useEffect(() => {
    loadSimData();
    loadRatings();
  }, []);

  useEffect(() => {
    if (!simData.preview) return;

    // display video overlay and play
    $(".poster").on("click", function () {
      $(this).parent().prev().fadeIn();
      const video = document.getElementsByTagName("video");
      if (video[0]) video[0].play();
    });

    // hide video overlay
    $(".simulation-blanket").on("click", function () {
      $(this).fadeOut();
      const video = document.getElementsByTagName("video");
      if (video[0]) video[0].pause();
    });

    // stop prop for video controls
    $(".simulation-video").on("click", function (e) {
      e.stopPropagation();
    });

    return () => {
      $(".poster").off("click");
      $(".simulation-blanket").off("click");
      $(".simulation-video").off("click");
    };
  }, [simData.preview]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openDocument = (event) => {
    event.preventDefault();
    const el = event.target.getAttribute("data-name");
    if (el) {
      window.open("/document/" + el);
    }
  };

  const openFacilitatorDocument = (event) => {
    event.preventDefault();
    const el = event.target.getAttribute("data-name");
    if (el) {
      window.open(el);
    }
  };

  const hasDocumentAccess = (docAccess, role) => {
    if (docAccess === "none") {
      return false;
    } else if (docAccess === "everyone") {
      return true;
    } else if (
      docAccess === "admin" &&
      (role === "Role_Super_Admin" || role === "Role_Admin")
    ) {
      return true;
    }
    return false;
  };

  const renderDescription = () => {
    const isOverMaxChars =
      simData.detailText?.length > MAX_CHARACTER_LIMITS_FOR_ELIPSIS;

    const truncatedText = isOverMaxChars
      ? simData.detailText.slice(0, MAX_CHARACTER_LIMITS_FOR_ELIPSIS) + "..."
      : simData.detailText;

    const toggleText = () => {
      setShowFullText(!showFullText);
    };

    return (
      <div>
        <span>
          {showFullText ? simData.detailText : truncatedText}
          {isOverMaxChars && (
            <button onClick={toggleText} className="more-button">
              {showFullText ? "Less" : "More"}
            </button>
          )}
        </span>
      </div>
    );
  };

  const documents = [
    {
      file: simData.docFile1,
      access: simData.docAccess1,
      name: simData.docName1,
    },
    {
      file: simData.docFile2,
      access: simData.docAccess2,
      name: simData.docName2,
    },
    {
      file: simData.docFile3,
      access: simData.docAccess3,
      name: simData.docName3,
    },
    {
      file: simData.docFile4,
      access: simData.docAccess4,
      name: simData.docName4,
    },
    {
      file: simData.docFile5,
      access: simData.docAccess5,
      name: simData.docName5,
    },
  ];

  const checkExistenceOfDocuments = () => {
    const simDocumentsList = documents && documents.map(
      (doc) => doc.file && hasDocumentAccess(doc.access, null)
    );
    const documentsExistOrNot = simDocumentsList?.every(
      (document) => !document
    );

    const simFacilitatorDocuments =
      simData.simFacilitatorDocumentsListBySimId &&
      simData.simFacilitatorDocumentsListBySimId.map(
        (doc) => doc.url && hasDocumentAccess(doc.access, null)
      );
    const simDocumentsExistOrNot = simFacilitatorDocuments?.every(
      (globalDoc) => !globalDoc
    );

    if (documentsExistOrNot && simDocumentsExistOrNot) {
      return true;
    }
    return false;
  };

  return (
    <div className="page-container-sim-detail">
      <div className="page-template page-template-list page-template-list-php page-id-54 wp-custom-logo wp-embed-responsive group-blog">
        <link media="all" href="/wordpress_design.css" rel="stylesheet" />
        <link media="all" href="/view_sim_page_design.css" rel="stylesheet" />
        <link
          rel="stylesheet"
          id="google-fonts-css"
          href="https://fonts.googleapis.com/css?family=Roboto%3A300%2C400%7CPlayfair+Display&amp;display=swap&amp;ver=0.5.3.1577824173"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="font-awesome-css"
          href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css?ver=0.5.3.1577824173"
          type="text/css"
          media="all"
        />

        <div className="site" id="page">
          <div id="wrapper-navbar">
            <a
              className="skip-link sr-only sr-only-focusable"
              href="#content"
            >
              Skip to content
            </a>
            <nav className="navbar navbar-expand-md navbar-light main-nav">
              <div className="container">
                <a
                  href="https://www.schoolsims.com/"
                  className="navbar-brand custom-logo-link"
                  rel="home"
                >
                  <img
                    width="250"
                    src={logo}
                    className="img-fluid"
                    alt={altAttribute.logoAlt}
                  />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="nav-interface">
                  <div
                    id="navbarNavDropdown"
                    className="collapse navbar-collapse"
                  >
                    <ul id="main-menu" className="navbar-nav ml-auto">
                      <li className="nav-item">
                        <a
                          title="Home"
                          href="https://www.schoolsims.com/"
                          className="nav-link"
                        >
                          Home
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          title="Simulations"
                          href="https://www.schoolsims.com/simulations/"
                          className="nav-link"
                        >
                          Simulations
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          title="About"
                          href="https://www.schoolsims.com/about/"
                          className="nav-link"
                        >
                          About
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          title="Blog"
                          href="https://www.schoolsims.com/blog/"
                          className="nav-link"
                        >
                          Blog
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          title="Contact Us"
                          href="https://www.schoolsims.com/contact/"
                          className="nav-link"
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>

          <div className="wrapper">
            {loading ? (
              <div className="overlay">
                <Loader loading={loading} />
              </div>
            ) : loadError ? (
              <section className="simulations-section p-0">
                <div className="view-sim-page-container">
                  <div className="content-view-page">
                    <div className="heading-view-sim-page">
                      Simulation not found
                    </div>
                    <div className="description-view-sim-page">
                      This simulation doesn't exist or is no longer available.
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <section className="simulations-section p-0">
                <div className="view-sim-page-container">
                  <div className="content-view-page">
                    <div className="heading-view-sim-page">
                      {simData.simName}
                    </div>

                    <div className="sim-duration-view-sim-page">
                      <div className={classes.root}>
                        <Rating
                          name="half-rating-read"
                          value={ratings}
                          precision={0.5}
                          readOnly
                          className="ratings-view-sim-page"
                        />
                      </div>
                      {simData.simDuration && (
                        <div>~{simData.simDuration}</div>
                      )}
                    </div>

                    <div className="description-view-sim-page">
                      {renderDescription()}
                    </div>

                    <div className="margin-for-buttons">
                      <IconButton onClick={handleClickOpen}>
                        <DescriptionIcon
                          aria-label="View Documentation"
                          className="description-icon-view-sim-page"
                        />
                      </IconButton>

                      <div
                        className="play-sim-heading-view-sim"
                        onClick={handleClickOpen}
                        tabIndex="0"
                        role="button"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleClickOpen();
                        }}
                      >
                        View Documentation
                      </div>
                    </div>

                    <Dialog
                      onClose={handleClose}
                      aria-labelledby="customized-dialog-title"
                      open={open}
                    >
                      <DialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                        className="close-dialog-view-sim"
                      >
                        Documents
                      </DialogTitle>
                      <DialogContent dividers>
                        {checkExistenceOfDocuments() ? (
                          <Typography className="no-documents-message">
                            No File Exists.
                          </Typography>
                        ) : (
                          <>
                            {documents.map(
                              (doc, index) =>
                                doc.file &&
                                hasDocumentAccess(doc.access, null) && (
                                  <Typography
                                    key={index}
                                    gutterBottom
                                    className="icons-text-display"
                                  >
                                    <DescriptionIcon className="dialog-desciption-icon margin-in-icons" />
                                    <a
                                      href="#"
                                      data-name={doc.file}
                                      onClick={(event) =>
                                        openDocument(event)
                                      }
                                      className="doc-name-view-sim-page"
                                    >
                                      {doc.name}
                                    </a>
                                  </Typography>
                                )
                            )}
                            {simData.simFacilitatorDocumentsListBySimId &&
                              simData.simFacilitatorDocumentsListBySimId.map(
                                (doc, i) => {
                                  const docDetail = doc;
                                  return (
                                    docDetail.url &&
                                    hasDocumentAccess(docDetail.access, null) && (
                                      <Typography
                                        key={i}
                                        gutterBottom
                                        className="icons-text-display"
                                      >
                                        <DescriptionIcon className="dialog-desciption-icon margin-in-icons" />
                                        <a
                                          href="#"
                                          className="global-doc-view-page doc-name-view-sim-page"
                                          data-name={docDetail.url}
                                          onClick={(event) =>
                                            openFacilitatorDocument(event)
                                          }
                                        >
                                          {docDetail.docName}
                                        </a>
                                      </Typography>
                                    )
                                  );
                                }
                              )}
                          </>
                        )}
                      </DialogContent>
                    </Dialog>
                  </div>
                </div>

                {simData.preview && (
                  <div className="additional-data">
                    <section className="simulations-section">
                      <div className="simulations wide">
                        <div className="simulation-blanket" style={{ display: "none" }}>
                          <div className="simulation-video-box">
                            <div className="close-section">
                              CLOSE <i className="fa fa-times"></i>
                            </div>
                            <div className="inner">
                              <div className="embed-container">
                                <Player
                                  className="simulation-video"
                                  playsInline
                                  src={`/video/${simData.preview}`}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="simulation single simulation-view-page single-view-page">
                          <div
                            className="poster"
                            style={{
                              marginTop: "15%",
                              width: "490px",
                              height: "300px",
                              ...(simData.thumbnail && {
                                backgroundImage: `url(/images/${simData.thumbnail})`,
                              }),
                            }}
                          >
                            <div className="playhead single_sim_playhead">
                              <div className="icon">
                                <i className="fa fa-play-circle"></i>
                              </div>
                              <div className="playhead-title">Preview</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                )}
              </section>
            )}
          </div>

          <div className="wrapper" id="wrapper-footer">
            <section className="footer-logos">{/* Footer content */}</section>
          </div>
        </div>
      </div>
      <FooterWithHelpIcon />
    </div>
  );
};

export default PublicSimDetail;
